"use client";

import { TrackedErrorPage } from "@/components/tracked-error-page";

export default function SiteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <TrackedErrorPage error={error} reset={reset} />;
}
